import React from "react";
import hoistNonReactStatic from "hoist-non-react-statics";
import { AuthConsumer } from "./context";

// a HOC that wraps the AuthConsumer component
export default WrappedComponent => {
  const WithAuth = ({ children, ...rest }) => (
    <AuthConsumer>
      {state => (
        <WrappedComponent {...rest} {...state}>
          {children}
        </WrappedComponent>
      )}
    </AuthConsumer>
  );

  WithAuth.displayName = `withAuth(${WrappedComponent.displayName ||
    WrappedComponent.name})`;
  WithAuth.WrappedComponent = WrappedComponent;

  return hoistNonReactStatic(WithAuth, WrappedComponent);
};
